import axios from "axios";

export const fetchSignedUrl = async (fileKey) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_COLLEGE_ERP_API}signedUrl?fileKey=${fileKey}`
    );
    const data = await response.json();

    if (data.url) {
      return data.url;
      //  window.open(data.url, "_blank"); // Open the PDF in a new tab
    } else {
      console.error("Failed to get signed URL");
    }
  } catch (error) {
    console.error("Error fetching signed URL:", error);
  }
};

export const getSignedUploadUrl = async (file, folderName) => {
  const response = await axios.get(
    `${process.env.REACT_APP_COLLEGE_ERP_API}get-upload-url`,
    {
      params: {
        fileName: file.name,
        folder: folderName,
        contentType: file.type,
      },
    }
  );
  return response.data; // { uploadUrl, fileKey }
};

export const uploadFileToS3 = async (uploadUrl, file) => {
  await axios.put(uploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
};

export const uploadFileAndGetKey = async (file, folderName) => {
  const { uploadUrl, fileKey } = await getSignedUploadUrl(file, folderName);
  await uploadFileToS3(uploadUrl, file);
  return fileKey;
};
